// Detects ATS vendor from a careers/jobs URL.
// Keep this focused and small; add mappings as needed.

const ATS_PATTERNS = [
  { key: 'greenhouse', name: 'Greenhouse', test: /(greenhouse\.io|boards\.greenhouse\.io)/i },
  { key: 'lever', name: 'Lever', test: /(lever\.co)/i },
  { key: 'workable', name: 'Workable', test: /(workable\.com)/i },
  { key: 'ashby', name: 'Ashby', test: /(ashbyhq\.com|jobs\.ashbyhq\.com)/i },
  { key: 'gem', name: 'Gem', test: /(jobs\.gem\.com)/i },
  { key: 'smartrecruiters', name: 'SmartRecruiters', test: /(smartrecruiters\.com)/i },
  { key: 'recruitee', name: 'Recruitee', test: /(recruitee\.com)/i },
  { key: 'jazzhr', name: 'JazzHR', test: /(jazzhr\.com)/i },
  { key: 'bamboohr', name: 'BambooHR', test: /(bamboohr\.com)/i },
];

export const detectAtsFromUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const match = ATS_PATTERNS.find((p) => p.test.test(url));
  return match || null;
};

export default detectAtsFromUrl;
